import React from "react";
import styles from "../../_css/SessionActions.module.css";
import { CustomButton, CustomButtonLight } from "../UI/CustomButtons";
import { X } from "lucide-react";
import { SESSION_ACTIONS_MODAL } from "../../data/modelsData";
import { useSelector } from "react-redux";

const SessionActions = ({
  show,
  onHide,
  generateSummary,
  saveSession,
  summary = false,
}) => {
  const lang = useSelector((state) => state.language.lang);
  const { title, actionTitle, btnText, btnText2 } = SESSION_ACTIONS_MODAL[lang];
  const handleGenerateSummary = () => {
    generateSummary();
  };
  const handleSaveSession = () => {
    saveSession();
  };

  if (!show) return null;

  return (
    <div className={styles.customModalOverlay}>
      <div className={styles.customModal}>
        <div className={styles.customModalHeader}>
          <h5 className={styles.title}>{title}</h5>
          <button className={styles.closeButton} onClick={onHide}>
            <X size={20} />
          </button>
        </div>
        <div className={styles.customModalBody}>
          <div>
            <i>
              <img
                width={40}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/file-icon.png`}
                alt="delete"
              />
            </i>
            <h5 className={styles.actionTitle}>{actionTitle}</h5>
          </div>
          <div className={styles.modeRow}>
            {!summary ? (
              <div className={styles.modeButtons}>
                <CustomButtonLight
                  onClick={handleGenerateSummary}
                  text={btnText[0]}
                  width="48%"
                  icon="text"
                />
                <CustomButtonLight
                  onClick={handleSaveSession}
                  text={btnText[1]}
                  width="48%"
                  icon="voice"
                  disabled={true}
                />
              </div>
            ) : (
              <div className={styles.modeButtons}>
                <CustomButtonLight
                  onClick={handleGenerateSummary}
                  text={btnText2[0]}
                  width="48%"
                />
                <CustomButton
                  onClick={handleSaveSession}
                  text={btnText2[1]}
                  width="48%"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionActions;
